import React from "react";
import { useHistory } from "react-router-dom";
import "../Dashboard/dashboard.css";
import "./managment.css";
import { Container, Navbar } from "react-bootstrap";
import openSectionIcon from "../../assets/images/open-secion-icon.png";
import { useSelector } from "react-redux";
import clsx from "clsx";
import RingLoaderShared from "../../shared/RingLoader/RingLoader";

const AdminMF = React.lazy(() => import("ChildAdmin/admin"));
const ManagmentHome = () => {
  const { isOpen } = useSelector((state) => state.design);
  const history = useHistory();

  return (
    <React.Suspense fallback={<RingLoaderShared  />}>
      <>
        <div
           style={{paddingTop : "20px"}}
          onClick={() => {
            history.push("/admin");
          }}
          className={clsx("div-dashboard", {
            "spacing-quality-managment": isOpen,
          })}
          id="qualityManagment"
          data-boolean="true"
        >
          <div className="container container-dashboard emplacement-quality-managment ">
            <div className="section-background">
              <Navbar>
                <Container>
                  <Navbar.Brand>
                    <AdminMF />
                  </Navbar.Brand>
                </Container>
              </Navbar>
            </div>
            <img
              className="center-icon"
              src={openSectionIcon}
              width="40"
              height="40"
            />
          </div>
        </div>
      </>
    </React.Suspense>
  );
};

export default ManagmentHome;
